<template>
	<div
		class="container__poligonosvg"
		v-html="svgPoligono"
	/>
</template>

<script>
import geojson2svg from 'geojson2svg'
import geojsonbounds from 'geojson-bounds'
import parseSVG from 'parse-svg'
import { bbox, bboxPolygon, lineString, length } from '@turf/turf'

import { getColorHexByCSSVariable } from '../../utils/themesHelper'

export default {
	props: {
		/**
		 * Objeto que contem o poligono junto com sua  altura e largura
		 */
		infoGeo: {
			type: Object,
			required: true,
		},
	},
	computed: {
		fill() {
			return this.$attrs.fill
		},
		fillOpacity() {
			return this.$attrs.fillOpacity || 22
		},
		stroke() {
			return this.$attrs.stroke
		},
		/**
		 * Propriedade computada que gera o svg para o poligono de
		 */
		svgPoligono() {
			if (this.infoGeo) {
				var { poligono, altura, largura } = this.infoGeo
				largura = largura || this.largura
				altura = altura || this.altura
				const [left, bottom, right, top] = geojsonbounds.extent(poligono)

				const fitTo = altura > largura ? 'height' : 'width'

				const color = getColorHexByCSSVariable('--color-primary')

				var converter = geojson2svg({
					attributes: {
						style: `stroke:${this.stroke || color}; fill: ${
							this.fill || color
						}; fill-opacity: ${this.fillOpacity}%; stroke-width:2px;`,
					},
					mapExtent: { left, bottom, right, top },
					fitTo,
				})
				const pathData = converter.convert(poligono)

				var svg = parseSVG(`<svg viewBox="0 0 256 256"">${pathData[0]}</svg>`)

				const bBox = this.getBBoxToHiddenSVG(svg)

				return `<svg viewBox="0 0 ${bBox.width} ${bBox.height}" width="100%" height="100%">${pathData[0]}</svg>`
			}
			return ''
		},
		/**
		 * Caso a propriedade 'infoGeo' vier sem largura, é possível calcula-la através do GeoJSON como demonstrado abaixo
		 */
		largura() {
			const polygon = bboxPolygon(bbox(this.infoGeo.poligono))
			const [minx, maxx] = polygon.geometry.coordinates[0]
			const lineLargura = lineString([minx, maxx])
			return length(lineLargura, { units: 'degrees' })
		},
		altura() {
			const polygon = bboxPolygon(bbox(this.infoGeo.poligono))
			const [, maxx, maxy] = polygon.geometry.coordinates[0]
			const lineAltura = lineString([maxx, maxy])
			return length(lineAltura, { units: 'degrees' })
		},
	},
	methods: {
		/**
		 * Retorna o tamanho do SVG para plotar os poligonos no card
		 */
		getBBoxToHiddenSVG(svg) {
			const element = document.createElement('div')
			element.appendChild(svg)
			const divGeraPoligono = document.querySelector('#gerarPoligono')
			divGeraPoligono.appendChild(element)
			const bBox = element.firstElementChild.firstElementChild.getBBox()
			divGeraPoligono.firstElementChild.remove()

			return bBox
		},
	},
}
</script>

<style scoped>
/* .container__poligonosvg {
  height: 100%;
  width: 100%;
} */
</style>
